export const authUamErrorKinds = {
  accountNotFound: 'AUTH_UAM_ACCOUNT_NOT_FOUND',
  inviteMembershipNotReady: 'AUTH_UAM_INVITE_MEMBERSHIP_NOT_READY',
  membershipSyncFailed: 'AUTH_UAM_MEMBERSHIP_SYNC_FAILED',
} as const;

export type AuthUamErrorKind = (typeof authUamErrorKinds)[keyof typeof authUamErrorKinds];

export type AuthUamErrorDetails = {
  kind: AuthUamErrorKind;
  clerkOrganizationId?: string;
  error?: string;
  organisationId?: string;
  reason?: string;
  retryable?: boolean;
  source?: string;
};

export const isAuthUamErrorKind = (value: unknown): value is AuthUamErrorKind =>
  typeof value === 'string' && Object.values(authUamErrorKinds).includes(value as AuthUamErrorKind);
